export default import.meta.ROLLDOWN_FILE_URL_eBB5uVE_t2Bb1etqpZE3Ig